import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-657963e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = { class: "message" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/img/checkbox-select.svg" }, null, -1))
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "cars" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vehicle_group_tile = _resolveComponent("vehicle-group-tile")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.model.show,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.show) = $event)),
    modal: true,
    dismissableMask: true,
    showHeader: false,
    breakpoints: { '649px': '90vw' },
    contentStyle: "overflow: overlay; padding: 0px; background-color: transparent;",
    style: {"width":"62.5rem"}
  }, {
    default: _withCtx(() => [
      (_ctx.model.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              src: "/img/close-btn.svg",
              class: "close-popup-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }),
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.message), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: _ctx.viewLink,
                class: "button",
                type: "button",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.viewButtonText), 1)
                ]),
                _: 1
              }, 8, ["to", "onClick"]),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                class: "button button--outline-blue"
              }, _toDisplayString(_ctx.i18n.t("otherDealsPopup.continueShopping")), 1)
            ]),
            (_ctx.model.cars.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.i18n.t("otherDealsPopup.title")), 1),
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.cars, (groupDto) => {
                      return (_openBlock(), _createBlock(_component_vehicle_group_tile, {
                        source: "vehicles-grouped",
                        filters: _ctx.getVehicleFilterQueryParameters,
                        class: "wow fadeIn",
                        "data-wow-offset": "100",
                        key: groupDto.hashcode,
                        "group-dto": groupDto,
                        onClosePopup: _ctx.close
                      }, null, 8, ["filters", "group-dto", "onClosePopup"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible"]))
}